







import {Component, Vue, Prop} from "vue-property-decorator";
import Attribute from "@/api/Product/Attribute";

@Component
export default class RenderProductAttributeMultiSelect extends Vue {
  @Prop() private attribute!: Attribute;

  hasOneItem() {
    if (this.attribute.baseValue) {
      return !this.attribute.baseValue.includes(",");
    }
    return true;
  }

  get centerClass() {
    if (this.hasOneItem()) {
      return "center-render";
    }
    return "";
  }
}
